import { useState } from "react";
import { useTranslation, Trans } from 'react-i18next';
import { useNavigate, useLocation, NavLink } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import logo from '../assets/oreo.png';
import close from '../assets/close.png';

const lngs = {
    en: { nativeName: 'English' },
    fr: { nativeName: 'Francais' }
  };

export default function Header(){
    const { t, i18n } = useTranslation();

    const [ isOpen, setIsOpen ] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const handleLanguage = (lang)=>{
        if (window.reactInit.langmode==='redirect'){
            window.location.href = window.reactInit[`${lang}url`]+location.pathname;
        } else {
            i18n.changeLanguage(lang)
        }
    }
    const collapse = ()=>{
        setIsOpen(false);
    }

    return (
        <Container fluid as="header"className="" >
            <Row className="align-items-center">
                <Col xs={6} lg={2}>
                    <NavLink to="/"><img src={logo} className="App-logo" alt="logo" /></NavLink>
                </Col>
                <Col className="d-none d-lg-flex justify-content-evenly gap-1">
                    {/* <NavLink to="/apply" onClick={collapse}>{t('header.apply')}</NavLink> */}
                    <NavLink to="/about" onClick={collapse}>{t('header.about')}</NavLink>
                    {/* <NavLink to="/teamoreo" onClick={collapse}>{t('header.team')}</NavLink> */}
                    <NavLink to="/recipients" onClick={collapse}>{t('header.recipients')}</NavLink>
                    <NavLink to="/faq" onClick={collapse}>{t('header.faq')}</NavLink>
                    <NavLink to="/rules" onClick={collapse}>{t('header.rules')}</NavLink>
                </Col>
                <Col xs={6} lg={2} className="text-end">
                    <div className="lang-toggle d-none d-lg-inline-block">
                    {Object.keys(lngs).map((lng) => (
                        <button key={lng} className={ i18n.resolvedLanguage === lng && 'active' } type="submit" onClick={() => handleLanguage(lng)}>
                        {lngs[lng].nativeName.substr(0,2)}
                        </button>
                    ))}
                    </div>
                    {/* login button */}
                    {/* <button onClick={()=>navigate('/login')} className="account-btn" /> */}
                    <button onClick={()=>setIsOpen(!isOpen)} className="menu-btn d-lg-none" />
                </Col>
                
            </Row>
            {isOpen && 
                <nav className="d-lg-none">
                    <button onClick={()=>setIsOpen(!isOpen)} className="close-btn" />
                    <NavLink to="/" onClick={collapse}>{t('header.home')}</NavLink>
                    <NavLink to="/about" onClick={collapse}>{t('header.about')}</NavLink>
                    <NavLink to="/recipients" onClick={collapse}>{t('header.recipients')}</NavLink>
                    {/* <NavLink to="/apply" onClick={collapse}>{t('header.apply')}</NavLink> */}
                    {/* <NavLink to="/teamoreo" onClick={collapse}>{t('header.team')}</NavLink> */}
                    <NavLink to="/faq" onClick={collapse}>{t('header.faq')}</NavLink>
                    <NavLink to="/rules" onClick={collapse}>{t('header.rules')}</NavLink>
                    <div className="lang-toggle">
                    {Object.keys(lngs).map((lng) => (
                        <button key={lng} className={ i18n.resolvedLanguage === lng && 'active' } type="submit" onClick={() => handleLanguage(lng)}>
                        {lngs[lng].nativeName.substr(0,2)}
                        </button>
                    ))}
                    </div>
                </nav>
            }
        </Container>
    );
}